import { render, staticRenderFns } from "./question2.vue?vue&type=template&id=c18d968a&scoped=true&"
import script from "./question2.vue?vue&type=script&lang=js&"
export * from "./question2.vue?vue&type=script&lang=js&"
import style0 from "./question2.vue?vue&type=style&index=0&id=c18d968a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c18d968a",
  null
  
)

export default component.exports